// src/components/Testimonials.jsx
import React, { useState } from 'react';

const Testimonials = () => {
    const [currentTestimonial, setCurrentTestimonial] = useState(0);

    const testimonials = [
        {
            id: 1,
            name: "Michael R.",
            role: "Car Enthusiast",
            content: "WadeBros transformed my 10-year-old car to look brand new. The attention to detail is incredible!",
            rating: 5
        },
        {
            id: 2,
            name: "Sarah L.",
            role: "Daily Commuter",
            content: "The interior detailing package made my car feel like new again. Worth every penny!",
            rating: 5
        },
        {
            id: 3,
            name: "David T.",
            role: "Classic Car Owner",
            content: "They treated my vintage Mustang with such care. The paint correction work was phenomenal.",
            rating: 5
        }
    ];

    const nextTestimonial = () => {
        setCurrentTestimonial((prev) => (prev + 1) % testimonials.length);
    };

    const prevTestimonial = () => {
        setCurrentTestimonial((prev) => (prev - 1 + testimonials.length) % testimonials.length);
    };

    return (
        <section id="testimonials" className="testimonials section">
            <div className="container">
                <div className="section-header">
                    <h2 className="section-title">Client Testimonials</h2>
                    <p className="section-subtitle">What our customers say about us</p>
                </div>

                <div className="testimonial-slider">
                    <button className="slider-arrow prev" onClick={prevTestimonial}>&larr;</button>

                    <div className="testimonial-content">
                        <div className="testimonial-rating">
                            {[...Array(testimonials[currentTestimonial].rating)].map((_, i) => (
                                <span key={i} className="star">★</span>
                            ))}
                        </div>
                        <p className="testimonial-text">"{testimonials[currentTestimonial].content}"</p>
                        <div className="testimonial-author">
                            <span className="author-name">{testimonials[currentTestimonial].name}</span>
                            <span className="author-role">{testimonials[currentTestimonial].role}</span>
                        </div>
                    </div>

                    <button className="slider-arrow next" onClick={nextTestimonial}>&rarr;</button>
                </div>
            </div>
        </section>
    );
};

export default Testimonials;